// Verificación del sello del documento sobre TanStack Query. Ruta pública: no
// depende de la sesión de `useAuth`, igual que `useAceptacionPublica`.

import { useQuery } from "@tanstack/react-query";

import { fetchDocumentoVerificado } from "@/lib/verificacionPublica";

export function useDocumentoVerificado(token: string | undefined) {
  return useQuery({
    queryKey: ["verificacion-publica", token] as const,
    queryFn: () => fetchDocumentoVerificado(token!),
    enabled: Boolean(token),
    // El 404 es un estado VÁLIDO del sello —ese código no corresponde a ningún
    // documento— y tiene su propia pantalla. Reintentarlo lo repetiría sin
    // cambiar nada.
    //
    // Ojo con lo que NO está acá: a diferencia de la aceptación, no hay 409 ni
    // 410 que distinguir. Una cotización anulada, vencida o ya aceptada
    // responde 200 y su estado viaja en el cuerpo — devolver un error dejaría
    // a quien tiene el papel sin saber si es falso o si solo lo reemplazaron.
    retry: false,
    // Lo que se verifica es un papel impreso: su contenido no cambia mientras
    // la pestaña está abierta, y el estado del sistema tampoco tan rápido como
    // para justificar un refetch al volver a la ventana.
    refetchOnWindowFocus: false,
  });
}
